import React from 'react';
import { compose } from 'redux';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import withStyles from '@material-ui/core/styles/withStyles';
import { Paper, Typography, Input, Avatar } from '@material-ui/core';
import { FormattedMessage } from 'react-intl'
const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
            width: 500,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(15),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(5)}px ${theme.spacing(5)}px`,
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(2),
        },
    },
    avatarIcon: {
        fontSize: 50,
    },
    title: {
        color: theme.palette.primary.main,
    },

})
class NotFound extends React.Component{
    render() {
        const { classes } = this.props;
        return (
            
            <main className={classes.main}>
                <Paper className={classes.paper}>
                    <Typography component="h1" variant="h5" >
                    404
                    </Typography>    
                    <Typography component="h1" variant="h5" className={classes.title}>
                        <FormattedMessage id="PageNotFound.Error" />
                    </Typography>
                </Paper>
            </main>);
    }
}
export default compose(withStyles(styles, { withTheme: true }))(NotFound);